import React from 'react';
import '../styles/new1-styles.css';

export default function HomeLastContent() {
    return (
        <section className="why-choose-section">
            <div className="why-choose-container">
                <div className="intro-block" data-aos="fade-up" data-aos-duration="1000">
                    <h1 className="section-title">Why Choose Ravline Corp?</h1>
                    <p className="section-subtitle">
                        Experience unmatched expertise, trust, and innovation in financial consulting. We empower our clients with tailored solutions and a commitment to excellence.
                    </p>
                </div>
                <div className="content-grid">
                    <div className="insights-block" data-aos="fade-right" data-aos-duration="1200">
                        <div className="insights-wrapper">
                            <h3 className="insights-title">2025-2026 Credit Trends</h3>
                            <div className="stats-grid">
                                <div className="stat-card" data-aos="fade-up" data-aos-delay="100">
                                    <span className="stat-number">715</span>
                                    <p>Average U.S. FICO Score <i>(Experian, Q3 2024)</i></p>
                                </div>
                                <div className="stat-card" data-aos="fade-up" data-aos-delay="200">
                                    <span className="stat-number">29%</span>
                                    <p>Credit Card Utilization Rate <i>(Experian)</i></p>
                                </div>
                                <div className="stat-card" data-aos="fade-up" data-aos-delay="300">
                                    <span className="stat-number">71%</span>
                                    <p>Consumers with Good Credit (670+) <i>(Experian)</i></p>
                                </div>
                                <div className="stat-card" data-aos="fade-up" data-aos-delay="400">
                                    <span className="stat-number">72%</span>
                                    <p>Adults Aware of Their Score <i>(Ravline Survey)</i></p>
                                </div>
                            </div>
                            <div className="generational-insights" data-aos="fade-up" data-aos-delay="500">
                                <h4 className="sub-title">Credit Scores by Generation</h4>
                                <ul className="generational-list">
                                    <li>Gen Z (18-27): <strong>681</strong></li>
                                    <li>Millennials (28-43): <strong>691</strong></li>
                                    <li>Gen X (44-59): <strong>709</strong></li>
                                    <li>Baby Boomers (60-78): <strong>746</strong></li>
                                    <li>Silent Generation (79+): <strong>760</strong></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="services-block" data-aos="fade-left" data-aos-duration="1200">
                        <div className="services-wrapper">
                            <h3 className="services-title">How Ravline Empowers You</h3>
                            <p className="services-intro">
                                Ravline credit support services help you navigate funding, homeownership, or business expansion with confidence.
                            </p>
                            <div className="services-grid">
                                <div className="service-card" data-aos="fade-up" data-aos-delay="100">
                                    <h4>Monitor Your Credit</h4>
                                    <p>Track your score and identify improvement opportunities with our tools.</p>
                                </div>
                                <div className="service-card" data-aos="fade-up" data-aos-delay="200">
                                    <h4>Improve Your Score</h4>
                                    <p>Keep utilization below 30% and avoid delinquencies with our guidance.</p>
                                </div>
                                <div className="service-card" data-aos="fade-up" data-aos-delay="300">
                                    <h4>Unlock Opportunities</h4>
                                    <p>Position yourself for better loans and rates with tailored strategies.</p>
                                </div>
                            </div>
                            <a href="#contact" className="cta-button" data-aos="fade-up" data-aos-delay="400">
                                Start Your Credit Journey
                            </a>
                        </div>
                    </div>
                </div>
                <div className="key-takeaways" data-aos="fade-up" data-aos-duration="1000">
                    <h3 className="takeaways-title">Key Takeaways for Your Financial Future</h3>
                    <ul className="takeaways-list">
                        <li>Maintain low credit utilization (&lt;30%) to boost your score.</li>
                        <li>Avoid delinquencies, as they significantly impact your credit health.</li>
                        <li>Regularly monitor your score to stay ahead of opportunities.</li>
                        <li>Build resilient credit habits to thrive in economic uncertainty.</li>
                    </ul>
                </div>
            </div>
        </section>
    );
}